import Button from '../buttons/Button';

import type { BannerConfig } from './useBannerConfig';

interface BannerButtonProps {
  config: BannerConfig;
  onButtonClick: (action: BannerConfig['action']) => void;
}

export const BannerButton = ({ config, onButtonClick }: BannerButtonProps) => {
  if (!config.showButton || !config.buttonText || !config.btnType) return null;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onButtonClick(config.action);
  };

  return (
    <Button
      btnType={config.btnType}
      className={config.buttonClass}
      classNameWrapper={config.buttonWrapperClass}
      dataTestId={config.dataTestId}
      handleOnClick={handleClick}
    >
      {config.buttonText}
    </Button>
  );
};
